module.exports = __webpack_public_path__ + "img/blue-filter-icon.a8a0e54b.svg";